<template>
  <div class="login-wrap">
    <div class="content">
      <img class="logo" src="/static/images/logos.jpg" alt="">
      <!-- <div class="logo"></div> -->
      <!-- <div class="text-logo">用醒市，有价值</div> -->
      <div class="form-wrap" style="width: 500px;">
      <div class="section">
        <div class="register">
          <div class="title">填写账户信息</div>
          <div class="form">
              <div class="lable">
                  <label for="name"><span>*</span> 账号/手机号</label>
                  <el-input v-model="username" @input="getUsername" autocomplete="off" placeholder="请输入账号/手机号..."></el-input>
              </div>
              <div class="lable">
                  <label for="name"><span>*</span> 登录密码</label>
                  <el-input v-model="password" @input="getPassword" show-password autocomplete="off" placeholder="请输入登录密码..."></el-input>
              </div>
              <div class="submit">
                  <button @click="login" type="primary">登录</button>
                  <button @click="register" type="primary">没有账户，去注册</button>
              </div>
          </div>
      </div>
      </div>
        <!-- <div class="section">
          <div class="qrcode-content">
            <div class="title">扫码登录</div>
            <div class="descrript">使用<span>微信</span>扫码自动登录</div>
            <div class="code">
              <img src="/static/images/ewm.jpg" alt="">
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div class="footer"> Copyright © 2026 新愿景 <a href="" target="_blank"></a>
    </div>
  </div>
</template>

<script>
  import { checkIn } from "@/api";
  export default {
    data() {
      return {
        username: "",
        password: "",
        keep: 0 // 记住登录:0=否,1=是  
      };
    },
    
    // 方法
    methods: {
      // 账号/手机号
        getUsername(val){
            console.log(val)
        },

        // 登录密码
        getPassword(val){
            console.log(val)
        },
      // 注册
      register(){
        this.$router.replace("/register")
      },
      // 登录
      login () {
        if (this.username === '') {
          this.$message.error('请输入账号/手机号');
          return
        }if (this.password === '') {
          this.$message.error('请输入登录密码');
          return
        } else {
            checkIn({
                username: this.username,
                password: this.password,
                keep: this.keep
            }).then(res => {
            console.log(res);
            if (res.data.code == 1) {
              let token = res.data.data.userInfo.token;
              let username = res.data.data.userInfo.username;
              localStorage.setItem("token", JSON.stringify(token));
              localStorage.setItem("username", JSON.stringify(username));
              // console.log(userInfo);
              // console.log(token);
              this.$message({
                message: res.data.msg,
                type: 'success'
              });
              this.$router.replace("/")
            } else {
              this.$message.error(res.data.msg);
            }
          }).catch(error => {
            this.$message.error('账号或密码错误');
            console.log(error);
          });
        }
      }
    },
    created() {
      // this.axios({
      //     method: 'post',
      //     url: 'http://192.168.0.9/api/user/login',
      //     data: {}
      // })
      // .then((res) => {
      //   console.log(res);
      // });
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login-wrap{
    height: 100vh;
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
}
.login-wrap .content {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    position: relative;
    width: 100%;
    background-image: url(../../static/images/bg.png);
    background-size: cover;
    --rightWid: 7.8%;
}
.login-wrap .content .logo {
    background-image: url(../../static/images/logo.png);
    position: absolute;
    top: 48px;
    left: 64px;
    /* width: 201.37px; */
    height: 100px;
    background-size: contain;
}
.login-wrap .content .text-logo {
    position: absolute;
    width: 540px;
    top: 70%;
    right: calc(700px + var(--rightWid));
    font-size: 48px;
    text-align: end;
    font-weight: 700;
    color: #fff;
}
.login-wrap .content .form-wrap, .login-wrap .content .section {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
}
.login-wrap .content .form-wrap {
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    padding: 24px 12px 24px 36px;
    right: var(--rightWid);
    width: 530px;
    height: calc(100% - 130px);
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    background: #fff;
    -webkit-box-shadow: 2px 4px 28px 1px rgba(0, 0, 0, .04), 2px 4px 18px 1px rgba(0, 0, 0, .08), 2px 4px 8px 1px rgba(0, 0, 0, .1);
    box-shadow: 2px 4px 28px 1px rgba(0, 0, 0, .04), 2px 4px 18px 1px rgba(0, 0, 0, .08), 2px 4px 8px 1px rgba(0, 0, 0, .1);
    border-radius: 12px 12px 12px 12px;
    opacity: 1;
    border: 2px solid #fff;
}
.login-wrap .content .section {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    -ms-flex-direction: column;
    flex-direction: column;
    padding-right: 24px;
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
    -ms-overflow-style: scrollbar;
    scrollbar-gutter: stable;
}
.qrcode-content {
    margin: auto;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}
.qrcode-content .title{
    height: 39px;
    font-size: 28px;
    font-weight: 700;
    color: #333;
}
.qrcode-content .descrript {
    margin-top: 12px;
    height: 25px;
    font-size: 18px;
    font-weight: 700;
    color: #333;
}
.qrcode-content .descrript span {
    font-size: 18px;
    color: #1dc11d;
}
.qrcode-content .code {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-top: 24px;
    border-radius: 0;
    opacity: 1;
    width: 250px;
    height: 250px;
}
.qrcode-content .code img {
    width: 250px;
    height: 250px;
}
.footer {
    background: #999;
    text-align: center;
    font-size: 14px;
    line-height: 52px;
    font-weight: 400;
    color: #fff;
}

/* .login {
  width: 100vw;
  height: 100vh;
  background: #f7f8fa url(../../static/images/bg.png) no-repeat center / cover;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login .form {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 65%;
  height: 60%;
  border-radius: 4px;
  padding: 0 5% 0 0;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0px -3px 54px 22px rgba(176, 167, 167, 0.2);
}
.login .form img {
  width: 52%;
}
.login .form .box {
  width: 48%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.login .text {
  font-size: 48px;
  text-align: center;
  margin-bottom: 32px;
  color: #333;
  font-weight: bold;
  line-height: 65px;
}
.login .label {
  width: 82%;
  margin-bottom: 20px;
}
.login .label > p {
  font-size: 20px;
  line-height: 28px;
  color: #000;
  margin-bottom: 6px;
}
.login .submit {
  width: 82%;
}
.login .label input,
.login .submit button {
  width: 100%;
  padding: 0 12px;
  font-size: 14px;
  border: 1px solid #c0c4cc;
  border-radius: 4px;
  line-height: 40px;
}
.login .submit button {
  background: #409eff;
  border: none;
  font-size: 20px;
  color: #fff;
  line-height: 45px;
  margin-top: 13px;
  cursor: pointer;
  text-align: center;
} */
.register .title{
    font-size: 18px;
    line-height: 1;
    font-weight: 400;
    color: #333;
    text-align: center;
    margin: 25px 0;
}
.lable{
    margin-bottom: 16px;
}
.lable label{
    font-size: 14px;
    color: #606266;
    margin-bottom: 6px;
    display: flex;
    align-items: flex-end;
    font-weight: bold;
}
.lable label span{
    color: #ff4949;
    margin-right: 4px;
}
.register .el-select, .register .el-cascader{
    width: 100%;
}
.submit button{
    width: 100%;
    height: 46px;
    -webkit-box-shadow: 2px 2px 18px 1px rgba(0,0,0,.08);
    box-shadow: 2px 2px 18px 1px rgba(0,0,0,.08);
    border-radius: 3px 3px 3px 3px;
    font-size: 16px;
    font-weight: 700;
    color: #fff;
    background-color: #409EFF;
    border-color: #409EFF;
    outline: none;
    border: 0;
    cursor: pointer;
}
.submit button:after{
    display: none;
}
.submit button:last-child{
    background: transparent;
    color: #999;
    box-shadow: none;
    line-height: normal;
    height: auto;
    display: block;
    /* justify-content: center; */
    width: auto;
    margin: 20px auto 0;
    font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue